import Quiz from "./Quiz.js";

function App() {
  return (
    <div className="App">
      <Quiz />
    </div>
  );
}

export default App;
